import React from 'react';
import { SiteClosingCta } from '../../components/site';
import { homeClosingCta } from './data';

export const HomeClosingCta: React.FC = () => (
  <SiteClosingCta
    titleId="io-home-closing-title"
    titleLines={homeClosingCta.titleLines}
    subtitle={homeClosingCta.subtitle}
    cta={homeClosingCta.cta}
  />
);
